// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentMoveMemberNumberBySurveyQuestionResultModelResponse {
    static getAttributeTypeMap() {
        return ExtEnrollmentMoveMemberNumberBySurveyQuestionResultModelResponse.attributeTypeMap;
    }
}
ExtEnrollmentMoveMemberNumberBySurveyQuestionResultModelResponse.discriminator = undefined;
ExtEnrollmentMoveMemberNumberBySurveyQuestionResultModelResponse.additionalProperties = false;
ExtEnrollmentMoveMemberNumberBySurveyQuestionResultModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "ExtEnrollmentMoveMemberNumberBySurveyQuestionResultModel"
    },
];
//# sourceMappingURL=extEnrollmentMoveMemberNumberBySurveyQuestionResultModelResponse.js.map